import { Chip, Paper, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { isArray, isString } from "lodash";
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
    // A barra gastava 64px de altura para exibir um controle cujo miolo tem
    // 28px; agora ocupa ~44px, apertando o padding que o Autocomplete "small"
    // aplica no OutlinedInput (6px) e no input (4.5px).
    //
    // Os seletores repetem os [class*=...] do próprio @material-ui/lab de
    // propósito: lá a regra é
    //   .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]
    // que tem especificidade (0,3,0). Um simples "& .MuiOutlinedInput-marginDense"
    // daria (0,2,0) e perderia calado.
    root: {
        padding: 6,
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'][class*='MuiOutlinedInput-marginDense']": {
            padding: 3,
            "& .MuiAutocomplete-input": {
                padding: "2.5px 4px",
            },
        },
        "& .MuiAutocomplete-tagSizeSmall": {
            margin: 1,
        },
    },
}));

export function TagsContainer({ ticket }) {
    const classes = useStyles();
    const history = useHistory();

    const [tags, setTags] = useState([]);
    const [selecteds, setSelecteds] = useState([]);
    const isMounted = useRef(true);

    // Desabilitar quando ticket estiver em pending
    const isDisabled = ticket?.status === "pending";

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        }
    }, [])

    // O catálogo de tags é da empresa, não do ticket: busca uma vez por ticket
    // aberto. Antes dependia do objeto `ticket` inteiro e refazia o GET a cada
    // update de socket (o merge sempre cria um objeto novo).
    useEffect(() => {
        if (isMounted.current) loadTags();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ticket?.id]);

    useEffect(() => {
        setSelecteds(Array.isArray(ticket?.tags) ? ticket.tags : []);
    }, [ticket?.tags]);

    const createTag = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    }

    const loadTags = async () => {
        try {
            const { data } = await api.get(`/tags/list`);
            if (!isMounted.current) return;
            setTags(data);
        } catch (err) {
            toastError(err);
        }
    }

    const syncTags = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags/sync`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    }

    const onChange = async (value, reason) => {
        if (isDisabled) return;
        let optionsChanged = []
        if (reason === 'create-option') {
            if (isArray(value)) {
                for (let item of value) {
                    if (isString(item)) {
                        const newTag = await createTag({ name: item })
                        optionsChanged.push(newTag);
                    } else {
                        optionsChanged.push(item);
                    }
                }
            }
            await loadTags();
        } else {
            optionsChanged = value;
        }

        setSelecteds(optionsChanged);
        await syncTags({ ticketId: ticket.id, tags: optionsChanged });
    }

    const handleDesenvolvimentoTagClick = () => {
        const contactId = ticket?.contactId || ticket?.contact?.id;
        const searchParams = new URLSearchParams();

        searchParams.set("tag", "desenvolvimento");
        if (contactId) {
            searchParams.set("contactId", String(contactId));
        }

        history.push(`/desenvolvimento?${searchParams.toString()}`);
    };

    return (
        <Paper className={classes.root}>
            <Autocomplete
                multiple
                size="small"
                options={tags}
                value={selecteds}
                disabled={isDisabled}
                freeSolo
                onChange={(e, v, r) => onChange(v, r)}
                getOptionLabel={(option) => option.name}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        (() => {
                            const isDesenvolvimentoTag =
                                String(option?.name || "").trim().toLowerCase() === "desenvolvimento";
                            const chipProps = getTagProps({ index });

                            return (
                                <Chip
                                    variant="outlined"
                                    style={{
                                        background: option.color || '#eee',
                                        color: "#FFF",
                                        marginRight: 1,
                                        fontWeight: 600,
                                        borderRadius: 3,
                                        fontSize: "0.8em",
                                        whiteSpace: "nowrap",
                                        cursor: isDesenvolvimentoTag ? "pointer" : "default",
                                    }}
                                    label={option.name.toUpperCase()}
                                    {...chipProps}
                                    size="small"
                                    onClick={(event) => {
                                        if (chipProps.onClick) {
                                            chipProps.onClick(event);
                                        }

                                        if (isDesenvolvimentoTag) {
                                            event.stopPropagation();
                                            handleDesenvolvimentoTagClick();
                                        }
                                    }}
                                />
                            );
                        })()
                    ))
                }
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" placeholder={i18n.t("tagsContainer.placeholder")} />
                )}
                PaperComponent={({ children }) => (
                    <Paper style={{ width: 400, marginLeft: 12 }}>
                        {children}
                    </Paper>
                )}
            />
        </Paper>
    )
}